//import {setToken} from "../API/Firebase"

'use strict'

import {setToken} from "@/api/firebase"
//import firebase from 'firebase'
// importScripts('https://www.gstatic.com/firebasejs/8.7.0/firebase-app.js')
// importScripts('https://www.gstatic.com/firebasejs/8.7.0/firebase-messaging.js')
// importScripts('https://www.gstatic.com/firebasejs/7.14.0/init.js')


//const firebaseMessaging =  firebase.messaging()

const firebaseConfig = {
  apiKey: "AIzaSyA2YME1-oqDPM2k1CTtKHL47jxKsXe7Yq4",
  authDomain: "recarga-te.firebaseapp.com",
  projectId: "recarga-te",
  storageBucket: "recarga-te.appspot.com",
  messagingSenderId: "713478208563",
  appId: "1:713478208563:web:2f040e50ebda1e9b18b746",
  measurementId: "G-WGDTM7R4E6"
};

firebase.initializeApp(firebaseConfig)


export let firebaseMessaging = firebase.messaging.isSupported() ? firebase.messaging() : null




if (firebaseMessaging) firebaseMessaging.usePublicVapidKey("BOH0VU_x8PHtoKVpBseWaYEfKGS3fYM1AV5DI161WAaz0wtOlHplamxMKczeRm77soT6EUYzvQw3KoP_Eu89_3c")

  // if(firebaseMessaging){
  //   firebaseMessaging.onMessage((payload) => {
  //     console.log('Message received. ', payload.data.event)
  //     console.log(JSON.parse(payload.data.data), `la data`)
  //     //console.log(app.nuxt.$emit)
  //     //$nuxt.$emit(`newNotificationFont`, JSON.parse(payload.data.data))
  //     $nuxt.$emit(`${payload.data.event}`, payload)
  //   })
  //
  // }



export function refreshToken() {

  const isServer = true

  const url = isServer ? `https://recarga-te.com/firebase-messaging-sw.js` : `http://localhost:8080/dist/firebase-messaging-sw.js`
  console.log(url, `esta es aurorpo,`)
  navigator.serviceWorker.register(url)
    .then((registration) => {
      console.log(firebaseMessaging.swRegistration, `asdasdasd`)
      if(!firebaseMessaging.swRegistration)
        firebaseMessaging.useServiceWorker(registration)
      firebaseMessaging.getToken().then((currentToken) => {
        console.log(212123132132)

        if (currentToken) {
          sendTokenToServer(currentToken)
        } else {
          console.log('No Instance ID token available. Request permission to generate one.')
          Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
              console.log('Notification permission granted.')
            } else {
              console.log('Unable to get permission to notify.')
            }
          })
          setTokenSentToServer(false)
        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err)
        setTokenSentToServer(false)
      })
    })
}

export function sendTokenToServer(currentToken) {
  console.log('mi token', currentToken)
  console.log('---------------------------------------------')
  if (!isTokenSentToServer() ) {
    console.log('Sending token to server...')
    setToken(currentToken).then(() => {
      setTokenSentToServer(true)
    }).catch(error => {
      console.log(error)
    })
  } else {
    console.log(`Token already sent to server so won't send it again, unless it changes`)
  }
}

export function isTokenSentToServer() {
  return window.localStorage.getItem('sentToServer') === '1'
}

export function setTokenSentToServer(sent) {
  window.localStorage.setItem('sentToServer', sent ? '1' : '0')
}
